import { CheckPlateComponent } from './check-plate/check-plate.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardMapComponent } from './dashboard-map/dashboard-map.component';
import { FineDetailsComponent } from './fine-details/fine-details.component';
import { FinesComponent } from './fines/fines.component';
import { FinesChartComponent } from './fines-chart/fines-chart.component';
import { HotelsComponent } from './hotels/hotels.component';
import { HotelAddComponent } from './hotel-add/hotel-add.component';
import { HotelDetailsComponent } from './hotel-details/hotel-details.component';
import { LoginHotelComponent } from './login-hotel/login-hotel.component';
import { ParkingLotsComponent } from './parking-lots/parking-lots.component';
import { ParkingAddComponent } from './parking-add/parking-add.component';
import { PaymentsComponent } from './payments/payments.component';
import { PaymentsChartComponent } from './payments-chart/payments-chart.component';
import { ProductsComponent } from './products/products.component';
import { ProductAddComponent } from './product-add/product-add.component';
import { SensorsComponent } from './sensors/sensors.component';
import { SupervisorComponent } from './supervisor/supervisor.component';
import { SupervisorsComponent } from './supervisors/supervisors.component';
import { SupervisorAddComponent } from './supervisor-add/supervisor-add.component';
import { SupervisorCheckedCarsComponent } from './supervisor-checked-cars/supervisor-checked-cars.component';
import { SupervisorFinesComponent } from './supervisor-fines/supervisor-fines.component';
import { TagsInputComponent } from './tags-input/tags-input.component';
import { UserComponent } from './user/user.component';
import { UserFinesComponent } from './user-fines/user-fines.component';
import { UserPaymentsComponent } from './user-payments/user-payments.component';
import { UsersComponent } from './users/users.component';
import { UsersChartComponent } from './users-chart/users-chart.component';
import { VehicleChecksComponent } from './vehicle-checks/vehicle-checks.component';

//#region Common
import { DropdownComponent } from './common/dropdown/dropdown.component';
import { DynamicMapComponent } from './common/dynamic-map/dynamic-map.component';
import { ImagePreviewComponent } from './common/image-preview/image-preview.component';
import { IncomingsTableComponent } from './common/incomings-table/incomings-table.component';
import { PaginationComponent } from './common/pagination/pagination.component';
import { SortComponent } from './common/sort/sort.component';
//#endregion

export {
    CheckPlateComponent, DashboardComponent, DashboardMapComponent,
    FineDetailsComponent, FinesComponent, FinesChartComponent,
    HotelsComponent, HotelAddComponent, HotelDetailsComponent,
    LoginHotelComponent, ParkingAddComponent,
    ParkingLotsComponent, PaymentsComponent, PaymentsChartComponent,
    ProductsComponent, ProductAddComponent, SupervisorsComponent,
    SensorsComponent, SupervisorComponent, SupervisorAddComponent,
    SupervisorCheckedCarsComponent, SupervisorFinesComponent,
    TagsInputComponent, UserComponent, UsersComponent,
    UserFinesComponent, UserPaymentsComponent, UsersChartComponent,
    VehicleChecksComponent,

    DropdownComponent,
    DynamicMapComponent, ImagePreviewComponent,
    IncomingsTableComponent,
    PaginationComponent, SortComponent
};
